import { Tabs } from '../../../components/Tabs';
import { useProductTab } from './useProductTab';
import { Link, useParams } from 'react-router';
import { getAdminCatalogProductEditPath } from '../adminRoutes';
import { CatalogEntityHeader } from './CatalogEntityHeader';
import { CatalogStatus } from './CatalogStatus';
import { CatalogRequestState } from './CatalogRequestState';
import { CatalogSaveNotice } from './CatalogSaveNotice';
import { CatalogProductOverview } from './CatalogProductOverview';
import { CatalogProductOffers } from './CatalogProductOffers';
import { useCatalogProductQuery } from './useCatalogProductEditor';
import './catalogEditor.css';

export function CatalogProductDetailPage() {
  const params = useParams();
  const { tab, setTab } = useProductTab();
  const productId = Number(params.productId);
  const isValidId = Number.isSafeInteger(productId) && productId > 0;
  const query = useCatalogProductQuery(isValidId ? productId : undefined);
  const product = query.data;
  const error = !isValidId ? 'Некорректный адрес страницы.' : query.error?.message;
  const editPath = getAdminCatalogProductEditPath(productId);
  return (
    <section className="admin-page catalog-workspace">
      <CatalogEntityHeader kind="products" title={product?.product_name ?? 'Товар'} subtitle={product ? `Товар · ${product.product_sku}` : 'Каталог'} status={product ? <CatalogStatus label={product.product_status_name || 'Статус не указан'} code={product.product_status_code} /> : null} actions={product ? <Link className="catalog-button catalog-button_primary" to={editPath}>Редактировать товар</Link> : null} />
      <CatalogSaveNotice />
      {product && !error ? <Tabs ariaLabel="Разделы товара" className="catalog-product-tabs" value={tab} onChange={setTab} items={[
        { value: 'main', title: 'Основное', content: <CatalogProductOverview product={product} /> },
        { value: 'offers', title: 'Предложения', content: <CatalogProductOffers key={productId} productId={productId} unit={product.product_unit_name || 'ед.'} /> },
      ]} /> : <CatalogRequestState error={error} onRetry={() => { void query.refetch(); }} />}
    </section>
  );
}
